export default __webpack_public_path__ + "assets/phone.6807b8.svg";